// ExitMaid Assistant (v2) — waits for DOM & logs visibly
(function init(){
  const ready = (fn)=> {
    if (document.readyState === 'complete' || document.readyState === 'interactive') return fn();
    document.addEventListener('DOMContentLoaded', fn, { once:true });
  };

  ready(function(){
    try {
      console.log('[EM] chat loader starting');

      // ===== inline chat UI (no external iframe files) =====
      const html = `<!doctype html><html><head>
<meta charset="utf-8"/><meta name="viewport" content="width=device-width,initial-scale=1"/>
<title>ExitMaid Assistant</title>
<style>
  body{margin:0;font:14px/1.45 system-ui,Segoe UI,Arial;background:#0b2447;color:#e7f1ff}
  .wrap{display:flex;flex-direction:column;height:100vh}
  .hdr{background:#0f3a5f;color:#fff;padding:10px 14px;font-weight:700}
  .msgs{flex:1;overflow:auto;padding:12px}
  .b{max-width:85%;margin:6px 0;padding:10px 12px;border-radius:12px}
  .bot{background:#0f3a5f;border-top-left-radius:4px}
  .me{background:#e7f1ff;color:#0b2447;margin-left:auto;border-top-right-radius:4px}
  form{display:flex;gap:8px;padding:10px;background:#0b2447;border-top:1px solid #0f3a5f}
  input{flex:1;padding:10px;border-radius:12px;border:1px solid #23486b;background:#0b2447;color:#e7f1ff}
  button{padding:10px 14px;border-radius:12px;border:0;background:#22d1ee;color:#012a3a;font-weight:700;cursor:pointer}
  .chips{display:flex;gap:8px;flex-wrap:wrap;padding:0 12px 10px}
  .chip{background:#113d63;border:1px solid #1b547f;border-radius:999px;padding:8px 12px;cursor:pointer}
</style>
</head><body>
<div class="wrap">
  <div class="hdr">ExitMaid Assistant</div>
  <div class="msgs" id="msgs">
    <div class="b bot">Hi! I can help with pricing, inclusions, bond-back details, and bookings. Try one:</div>
    <div class="chips" id="chips"></div>
  </div>
  <form id="f"><input id="q" placeholder="Type your question…" autocomplete="off"/><button>Send</button></form>
</div>
<script>
const endpoint="https://pklvvqthllpcbiypxjpa.supabase.co/functions/v1/exitmaid-chat";
const msgs=document.getElementById('msgs'),chips=document.getElementById('chips');
const f=document.getElementById('f'),q=document.getElementById('q');
const sessionKey='em_session'; if(!localStorage.getItem(sessionKey)) localStorage.setItem(sessionKey,crypto.randomUUID());
["Get a quote","What’s included?","Bond-back guarantee","Carpet steam cleaning","Talk to a human"].forEach(t=>{const c=document.createElement('div');c.className='chip';c.textContent=t;c.onclick=()=>ask(t);chips.appendChild(c);});
function push(text,who='me'){const b=document.createElement('div');b.className=\`b \${who}\`;b.innerHTML=text;msgs.appendChild(b);msgs.scrollTop=msgs.scrollHeight;}
async function ask(text){
  push(text,'me');
  try{
    const res=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({mode:'chat',session_id:localStorage.getItem(sessionKey),message:text,page:document.referrer||location.href})});
    const data=await res.json(); push((data.reply||'Sorry, I didn’t catch that.'),'bot');
    try{parent.gtag('event','chat_started');}catch(e){} try{parent.fbq('trackCustom','ChatStarted');}catch(e){}
  }catch(e){push('Hmm, something went wrong. Please try again or request a quick quote.','bot');}
}
f.addEventListener('submit',e=>{e.preventDefault();if(q.value.trim()) ask(q.value.trim()),q.value='';});
</script></body></html>`;

      // launcher
      if (document.getElementById('em-chat')) return; // avoid duplicates
      const mount=document.createElement('div');
      mount.id='em-chat';
      mount.style.cssText='position:fixed;bottom:20px;right:20px;z-index:99999';
      document.body.appendChild(mount);

      const btn=document.createElement('button');
      btn.textContent='Chat with ExitMaid';
      btn.setAttribute('aria-label','Open chat');
      btn.style.cssText='background:#0b2447;color:#fff;border:none;padding:12px 16px;border-radius:999px;box-shadow:0 6px 16px rgba(0,0,0,.18);cursor:pointer;font-weight:600';
      mount.appendChild(btn);

      const panel=document.createElement('div');
      panel.style.cssText='position:fixed;bottom:84px;right:20px;width:360px;max-width:90vw;height:560px;max-height:80vh;background:#0b2447;border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,.35);display:none;overflow:hidden';
      panel.innerHTML='<div style="background:#0f3a5f;color:#fff;padding:12px 16px;font-weight:700">ExitMaid Assistant</div>';
      const iframe=document.createElement('iframe');
      iframe.title='ExitMaid Assistant';
      iframe.style.cssText='width:100%;height:calc(100% - 48px);border:0;background:#0b2447';
      iframe.srcdoc=html;
      panel.appendChild(iframe);
      document.body.appendChild(panel);

      btn.addEventListener('click',()=>{
        panel.style.display = panel.style.display==='none' ? 'block' : 'none';
        if(panel.style.display==='block'){
          try{window.gtag && gtag('event','chat_opened');}catch(e){}
          try{window.fbq && fbq('trackCustom','ChatOpened');}catch(e){}
        }
      });

      console.log('[EM] chat launcher mounted');
    } catch (err) {
      console.error('[EM] chat init error', err);
    }
  });
})();
